import React from "react";
import { ZONES, zoneIndexForPage } from "../lib/reader";

// Procedural contour swatch — tighter lines = more bracing, wider = more ease.
export const ContourSwatch = ({ gap = 10, size = 40, className = "" }) => {
  const lines = [];
  for (let y = gap / 2; y < size; y += gap) {
    const mid = size / 2;
    const bow = (1 - Math.abs(y - mid) / mid) * (gap * 0.5);
    lines.push(
      <path
        key={y}
        d={`M0 ${y} Q ${size / 2} ${y - bow} ${size} ${y}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.8"
      />
    );
  }
  return (
    <svg viewBox={`0 0 ${size} ${size}`} className={className} width={size} height={size} aria-hidden="true">
      {lines}
    </svg>
  );
};

// BRACED -> FREE elevation chart with a "you are here" marker.
export const TrailProfile = ({ currentPage, zonesRead = [], onJump, reducedMotion }) => {
  const W = 320;
  const H = 116;
  const padX = 14;
  const padTop = 16;
  const padBottom = 26;
  const n = ZONES.length;
  const here = zoneIndexForPage(currentPage);
  const x = (i) => padX + (i * (W - padX * 2)) / (n - 1);
  // bracing high at start -> free (low) at end
  const y = (i) => padTop + (i * (H - padTop - padBottom)) / (n - 1);
  const pts = ZONES.map((_, i) => `${x(i)},${y(i)}`).join(" ");
  const readCount = here < 0 ? 0 : here;
  const areaPts =
    here >= 0
      ? `${x(0)},${H - padBottom} ` +
        ZONES.slice(0, here + 1).map((_, i) => `${x(i)},${y(i)}`).join(" ") +
        ` ${x(Math.max(0, here))},${H - padBottom}`
      : "";

  return (
    <div data-testid="trail-profile" className="w-full">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full" role="img" aria-label="Trail profile from braced to free">
        <text x={padX} y={10} className="fill-ink-muted" fontSize="7" letterSpacing="1.5">BRACED</text>
        <text x={W - padX} y={10} textAnchor="end" className="fill-gold-deep" fontSize="7" letterSpacing="1.5">FREE</text>
        <line x1={padX} y1={H - padBottom} x2={W - padX} y2={H - padBottom} stroke="#C9BFA6" strokeWidth="0.6" strokeDasharray="2 3" />
        {areaPts && <polygon points={areaPts} fill="#B9A86A" opacity="0.18" />}
        <polyline points={pts} fill="none" stroke="#9C8B5E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        {ZONES.map((z, i) => {
          const isHere = i === here;
          const isRead = i < here || zonesRead.includes(z.id);
          return (
            <g key={z.id} onClick={() => onJump && onJump(z.start_page)} style={{ cursor: "pointer" }} data-testid={`trail-zone-${z.id}`}>
              <rect x={x(i) - 18} y={padTop - 4} width="36" height={H - padBottom - padTop + 16} fill="transparent" />
              <circle cx={x(i)} cy={y(i)} r={isHere ? 5 : 3.4} fill={isHere ? "#A9833F" : isRead ? "#C9A85E" : "#FBFAF7"} stroke={isHere ? "#7A5F2D" : "#A99A6A"} strokeWidth="1" />
              {isHere && !reducedMotion && (
                <circle cx={x(i)} cy={y(i)} r="5" fill="none" stroke="#A9833F" strokeWidth="1">
                  <animate attributeName="r" values="5;11;5" dur="2.4s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.7;0;0.7" dur="2.4s" repeatCount="indefinite" />
                </circle>
              )}
              <text x={x(i)} y={H - padBottom + 11} textAnchor="middle" className="fill-ink-muted" fontSize="5.5">{String(1400 - i * 180)}</text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};
